<template>
    <page :busy="busy" :tabs="tabs">
        <grid
            ref="grid"
            :columnDefs="columnDefs"
            :fetchCallback="fetchCallback"
        >
            <div class="toolbar">
                <responsive-button
                    :icon="['fas', 'arrows-rotate']"
                    @click="refresh"
                    variant="primary"
                >Refresh</responsive-button>
                <responsive-button
                    :icon="['fas', 'plus']"
                    :with-space="false"
                    :disabled="!!backupProgress"
                    variant="primary"
                    @click="handleBackupCreate"
                >Create Backup</responsive-button>
                <b-progress class="mt-2" v-if="backupProgress" height="2rem">
                    <b-progress-bar :value="backupProgress">
                       {{ backupProgress }}%
                    </b-progress-bar>
                </b-progress>
            </div>
        </grid>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Grid from '../../generic/grid/grid.vue';
    import Page from '../../generic/page/page.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import { WebSocketClient } from '../../../websocket/client';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

    export default {
        name: 'BackupHistory',
        components: {
            Grid,
            Page,
            ResponsiveButton,
            actionsCellRenderer: ActionsCellRenderer,
        },
        mixins: [removeScrollMixin],
        computed: {
            ...mapGetters('header', ['userWebsocketToken']),
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get('/app/backup/backup/grid/', {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        }
                    });
                };
            },
        },
        data() {
            return {
                busy: false,
                tabs: [
                    {
                        'title': 'History',
                        'route': '/app/backup/history/',
                        'active': true
                    }
                ],
                columnDefs: [
                    {
                        field: 'id',
                        type: 'idColumn',
                        maxWidth: 80,
                    },
                    {
                        field: 'made',
                        type: 'dateTimeColumn',
                        headerName: 'Date',
                        minWidth: 150,
                    },
                    {
                        headerName: '',
                        minWidth: 180,
                        maxWidth: 180,
                        resizable: false,
                        cellStyle: { textAlign: 'center' },
                        sortable: false,
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            backupProgressGetter: () => this.backupProgress,
                            delete: async ({ node }) => {
                                const row = node.data;
                                try {
                                    await API.delete(`/app/backup/backup/${row.id}/`);
                                    this.refresh();
                                } catch (error) {
                                    this.errorToast({text: `Could not delete backup.`});
                                }
                            },
                            restore: async ({ node, api }) => {
                                const row = node.data;
                                try {
                                    await API.post(`/app/backup/backup/${row.id}/restore/`, {
                                        websocket_token: this.userWebsocketToken,
                                    });
                                } catch (error) {
                                    this.errorToast({text: `Could not restore backup.`});
                                }
                            }
                        }
                    },
                ],
                websocketClient: new WebSocketClient(),
                backupProgress: null,
                offset: 0,
                limit: 20,
                sort: 'id',
                desc: false,
                search: '',
            }
        },
        mounted() {

        },
        methods: {
            handleBackupCreate() {
                return API.post('/app/backup/backup/', {
                    websocket_token: this.userWebsocketToken,
                })
            },
            handleWebsocketMessage(message) {
                this.backupProgress = this.getProgress(message.msg);
            },
            getProgress(str) {
                const regexp = /(START|PROGRESS|STOP),(\d+)/i;
                const result = str && str.match(regexp);
                return (result && Number(result[2])) || null;
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            }
        },
        watch: {
            backupProgress() {
                if (this.backupProgress === 100) {
                    this.backupProgress = null;
                    this.successToast({text: `Backup successfully finished.`})
                    this.refresh();
                }
            },
            userWebsocketToken(newVal, oldVal) {
                this.websocketClient.initialize({ token: this.userWebsocketToken });
                this.websocketClient.setMessageCallback(this.handleWebsocketMessage);                
            }            
       }
    }
</script>